<p-tabs [value]="selectedTab()">
    <p-tablist>
        <p-tab value="account" routerLink="account">{{ 'user.profile.account' | translate }}</p-tab>
        <p-tab value="preferences" routerLink="preferences">{{ 'user.profile.preferences.title' | translate }}</p-tab>
        <p-tab value="security" routerLink="security">{{ 'user.profile.security' | translate }}</p-tab>
        <p-tab value="msg" routerLink="msg">{{ 'user.profile.messages' | translate }}</p-tab>
        <p-tab value="wysiwyg" routerLink="wysiwyg">{{ 'user.profile.wysiwyg.title' | translate }}</p-tab>
        <p-tab value="electronic-signature" routerLink="electronic-signature">
            {{ 'user.profile.electronicSignature.title' | translate }}
        </p-tab>
        @if (dashboardSettingsEnabled) {
            <p-tab value="dashboard" routerLink="dashboard">
                {{ 'user.profile.dashboardSettings.title' | translate }}
            </p-tab>
        }
    </p-tablist>
</p-tabs>

<div class="p-3">
    <router-outlet></router-outlet>
</div>
